export default "__VITE_ASSET__8d04c664__"